import React, { useState } from 'react'
import { BoxArrowUpRight, ChevronDown } from 'react-bootstrap-icons'
import { getCurrentPhase, PHASE_DOT_CLASS, PHASE_LABEL } from './clientCampaignStatus'

function OngoingCampaignRow({ campaign, rowHeight, onCampaignClick, hideCampaignLink }) {
  const accentColor = campaign.theme_color || '#6b7280'
  const currentPhase = getCurrentPhase(campaign)
  const dotClass = currentPhase ? (PHASE_DOT_CLASS[currentPhase.phase] || PHASE_DOT_CLASS.main) : null
  const phaseLabel = currentPhase ? (PHASE_LABEL[currentPhase.phase] || currentPhase.phase) : null

  return (
    <div
      className="flex flex-shrink-0 cursor-pointer items-center gap-2 border-b border-rb-widget-border px-4 hover:bg-rb-grey dark:border-rb-dark-mode-lighter dark:hover:bg-rb-dark-mode-lighter/50"
      style={{ height: rowHeight }}
      onClick={() => onCampaignClick?.(campaign)}
      title={campaign.name}
    >
      <span
        className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded text-[8px] font-bold text-white"
        style={{ backgroundColor: accentColor }}
      >
        {campaign.name.slice(0, 2).toUpperCase()}
      </span>
      <span className="min-w-0 flex-1 truncate text-xs font-medium dark:text-white">
        {campaign.name}
      </span>
      {dotClass && phaseLabel && (
        <span className="flex flex-shrink-0 items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
          <span className={`h-1.5 w-1.5 rounded-full ${dotClass}`} />
          {phaseLabel}
        </span>
      )}
      {!hideCampaignLink && (
        <a
          href={`/project_manager/campaigns/${campaign.id}/overview`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="ml-1 flex-shrink-0 text-gray-300 hover:text-rb-black dark:hover:text-white"
          title="Open campaign"
          aria-label="Open campaign"
        >
          <BoxArrowUpRight style={{ fontSize: 11 }} />
        </a>
      )}
    </div>
  )
}

function EndedCampaignRow({ campaign, hideCampaignLink }) {
  const accentColor = campaign.theme_color || '#6b7280'

  return (
    <div className="flex items-center gap-2 px-4 py-2.5">
      <span
        className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded text-[8px] font-bold text-white opacity-50 grayscale"
        style={{ backgroundColor: accentColor }}
      >
        {campaign.name.slice(0, 2).toUpperCase()}
      </span>
      <span className="min-w-0 flex-1 truncate text-xs font-medium text-gray-400 dark:text-gray-500">
        {campaign.name}
      </span>
      {!hideCampaignLink && (
        <a
          href={`/project_manager/campaigns/${campaign.id}/overview`}
          target="_blank"
          rel="noopener noreferrer"
          className="ml-1 flex-shrink-0 text-gray-300 hover:text-rb-black dark:hover:text-white"
          title="Open campaign"
          aria-label="Open campaign"
        >
          <BoxArrowUpRight style={{ fontSize: 11 }} />
        </a>
      )}
    </div>
  )
}

export default function ClientCampaignTimelineSidebar({
  campaigns,
  endedCampaigns = [],
  title,
  headerHeight,
  rowHeight,
  onCampaignClick,
  hideCampaignLink = false,
}) {
  const [endedExpanded, setEndedExpanded] = useState(false)

  return (
    <div
      className="flex flex-shrink-0 flex-col border-r border-rb-widget-border bg-white dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode"
      style={{ width: 280 }}
    >
      <div
        className="flex flex-shrink-0 items-end justify-between border-b border-rb-widget-border px-4 pb-3 dark:border-rb-dark-mode-lighter"
        style={{ height: headerHeight }}
      >
        <span className="text-sm font-semibold dark:text-white">{title}</span>
        <span className="text-sm text-gray-400">{campaigns.length}</span>
      </div>

      {campaigns.map((campaign) => (
        <OngoingCampaignRow
          key={campaign.id}
          campaign={campaign}
          rowHeight={rowHeight}
          onCampaignClick={onCampaignClick}
          hideCampaignLink={hideCampaignLink}
        />
      ))}

      {endedCampaigns.length > 0 && (
        <div className="border-t border-rb-widget-border dark:border-rb-dark-mode-lighter">
          <button
            type="button"
            onClick={() => setEndedExpanded((prev) => !prev)}
            className="flex w-full items-center justify-between px-4 py-3 text-xs font-semibold text-gray-500 hover:bg-rb-grey dark:text-gray-400 dark:hover:bg-rb-dark-mode-lighter/50"
          >
            <span>Ended ({endedCampaigns.length})</span>
            <ChevronDown
              className={`shrink-0 text-sm transition-transform duration-200 ${endedExpanded ? 'rotate-180' : ''}`}
            />
          </button>
          {endedExpanded &&
            endedCampaigns.map((campaign) => (
              <EndedCampaignRow key={campaign.id} campaign={campaign} hideCampaignLink={hideCampaignLink} />
            ))}
        </div>
      )}
    </div>
  )
}
